import React from 'react';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';

/** @component */
export const PrintHeader = withStyles(() => createStyles({
  header: {
    display: 'none',
    '@media print': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  hospiceName: {
    fontSize: '1rem'
  },
  siteName: {
    fontSize: '.8rem'
  }
}))(({
  classes,
  hospiceName,
  siteName
}) => /*#__PURE__*/React.createElement("header", {
  className: classes.header
}, hospiceName ? /*#__PURE__*/React.createElement(Typography, {
  className: classes.hospiceName
}, hospiceName) : null, siteName ? /*#__PURE__*/React.createElement(Typography, {
  className: classes.siteName
}, siteName) : null));
export default PrintHeader;